"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with form data
 */
class FormsDataApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/form-data';
    }
    /**
     * Get all forms data.
     *
     * @param {string} [langCode] - Language code. Default "en_US"
     * @param {number} [offset] - Parameter for pagination. Default 0
     * @param {number} [limit] - Parameter for pagination. Default 30
     *
     * @returns Returns array for all objects of FormData
     */
    async getFormsData(langCode = 'en_US', offset = 0, limit = 30) {
        const result = await this._fetchGet(`?langCode=${langCode}&offset=${offset}&limit=${limit}`);
        return result;
    }
    /**
     * Find all product page objects with pagination and multiple filtering.
     *
     * @param {object} [data] - Request body.
     * Example Value:
     * {
     *   "formIdentifier": "my-form",
     *   "formData": [
     *     {
     *       "marker": "name_1",
     *       "value": "Name",
     *       "langCode": "en_US"
     *     }
     *   ]
     * }
     *
     * @returns - Returns created FormData objects.
     */
    async postFormsData(data) {
        const result = await this._fetchPost('', data);
        return result;
    }
    /**
     * Get one object of form data by marker.
     *
     * @param {string} [marker] - Marker of the form data
     * @param {string} [langCode] - Language code. Default "en_US"
     * @param {number} [offset] - Parameter for pagination. Default 0
     * @param {number} [limit] - Parameter for pagination. Default 30
     *
     * @returns Returns array of object FormDataEntity
     */
    async getFormsDataByMarker(marker, langCode = 'en_US', offset = 0, limit = 30) {
        const result = await this._fetchGet(`/${marker}?langCode=${langCode}&offset=${offset}&limit=${limit}`);
        return result;
    }
}
exports.default = FormsDataApi;
